import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Extension from "../views/extension.vue";
import Luckdraw from "../views/luckdraw.vue";
import ExtensionNew from "../views/extensionNew.vue";
import Animation from "../views/animation.vue";
import VersionManagement from "../views/versionManagement.vue";
import LicenseAgreement from "../views/licenseAgreement.vue";
import OfficialAccount from "../views/officialAccount.vue";
import Active from "../views/active.vue";
import Syntunys from "../views/syntunys.vue";

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "Home",
    meta: {
      title: "弦镜"
    },
    component: Home
  },
  {
    path: "/extension",
    name: "Extension",
    meta: {
      title: "弦镜"
    },
    component: Extension
  },
  {
    path: "/luckdraw",
    name: "Luckdraw",
    meta: {
      title: "弦镜"
    },
    component: Luckdraw
  },
  {
    path: "/extensionNew",
    name: "ExtensionNew",
    meta: {
      title: "弦镜推广大使活动"
    },
    component: ExtensionNew
  },
  {
    path: "/animation",
    name: "Animation",
    meta: {
      title: "弦镜产品介绍"
    },
    component: Animation
  },
  {
    path: "/versionManagement",
    name: "VersionManagement",
    meta: {
      title: "版本管理"
    },
    component: VersionManagement
  },
  {
    path: "/licenseAgreement",
    name: "LicenseAgreement",
    meta: {
      title: "授权协议"
    },
    component: LicenseAgreement
  },
  {
    path: "/officialAccount",
    name: "officialAccount",
    meta: {
      title: "星图数据"
    },
    component: OfficialAccount
  },
  {
    path: "/active",
    name: "Active",
    meta: {
      title: "星图数据"
    },
    component: Active
  },
  {
    path: "/syntunys",
    name: "Syntunys",
    meta: {
      title: "星图数据"
    },
    component: Syntunys
  },
  {
    path: "/shareUserCollection",
    name: "shareUserCollection",
    meta: {
      title: "星图数据"
    },
    component: () => import('../views/shareUserCollection.vue')
  },
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;